var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',{attrs:{"view":"Lhh lpr lFf"}},[_c('q-header',{staticClass:"bg-grey-7 text-white",staticStyle:{"position":"fixed"},attrs:{"elevated":""}},[_c('toolbar')],1),_vm._v(" "),_c('q-drawer',{attrs:{"bordered":"","show-if-above":""},model:{value:(_vm.leftDrawer),callback:function ($$v) {_vm.leftDrawer=$$v},expression:"leftDrawer"}},[_c('drawer')],1),_vm._v(" "),_c('q-page-container',[_c('child')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-189d4326","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/layouts/admin.vue
// module id = null
// module chunks = 